import { Injectable } from '@angular/core';
import { SdkInitText } from '../../model/user/sdk-init-text';

@Injectable({
  providedIn: 'root'
})
export class MessageService {
  message: string;
  sdkInitTexts: Array<SdkInitText>;

  getMessage(): string {
    return this.message;
  }

  setMessage(value: string) {
    this.message = value;
  }

  getSdkInitTexts() {
    return this.sdkInitTexts;
  }

  setSdkInitTexts(sdkInitTexts: Array<SdkInitText>) {
    this.sdkInitTexts = sdkInitTexts;
  }
}
